import { useRef } from 'react';
import type { StepProps } from './types';

const WORK_STYLES = [
  '常勤（夜勤OK）',
  '常勤（夜勤NG）',
  '非常勤（夜勤OK）',
  '非常勤（夜勤NG）',
  'こだわらない',
];

type Props = Pick<StepProps, 'formData' | 'onChange' | 'onNext' | 'onBack'>;

const backBtnStyle: React.CSSProperties = {
  background: 'transparent',
  border: 'none',
  color: '#bbb',
  fontSize: '12px',
  cursor: 'pointer',
  padding: '4px 8px',
  textDecoration: 'underline',
};

export default function StepWorkStyle({ formData, onChange, onNext, onBack }: Props) {
  // 単一選択 → 自動で次のステップへ進む。誤タップ救済のため 350ms ディレイ。
  // 既に進行予約中の場合は連打で複数回 onNext されないようガード。
  const advanceTimerRef = useRef<number | null>(null);

  const handleSelect = (item: string) => {
    onChange('workStyle', item);
    if (advanceTimerRef.current !== null) {
      window.clearTimeout(advanceTimerRef.current);
    }
    advanceTimerRef.current = window.setTimeout(() => {
      onNext();
      advanceTimerRef.current = null;
    }, 350);
  };

  return (
    <div>
      <p style={{ fontWeight: 700, fontSize: '15px', marginBottom: '4px', color: '#333' }}>
        Q2. 希望の働き方を選んでください
      </p>
      <p style={{ fontSize: '12px', color: '#aaa', marginBottom: '14px' }}>※選択すると自動で次へ進みます</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '8px', marginBottom: '20px' }}>
        {WORK_STYLES.map((item) => {
          const selected = formData.workStyle === item;
          return (
            <button
              key={item}
              type="button"
              onClick={() => handleSelect(item)}
              className={`choice-label${selected ? ' selected' : ''}`}
              style={{ border: selected ? '1.5px solid #fa7c9e' : '1.5px solid #f0c8d4' }}
            >
              {item}
            </button>
          );
        })}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
        <button style={backBtnStyle} onClick={onBack}>
          ← 前の質問に戻る
        </button>
      </div>
    </div>
  );
}